/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';              // ⬅ add this
import '../index.css';
import './components.css';
import Menu from './Menu';
import SkipLink from './SkipLink';
import { NavLink, useLocation } from 'react-router-dom';
import { useStateValue } from '../ContextApi/StateProvider';

const NavBar = () => {
  const [initialState, dispatch] = useStateValue();
  const authUser = initialState.authenticatedUser ? JSON.parse(initialState.authenticatedUser) : null;
  const { pathname } = useLocation();
  const [themeLabel, setThemeLabel] = useState('Dark Mode');

  useEffect(() => {
    if (initialState.menuOpen) {
      dispatch({ type: 'SET_MENU_OPEN', menuOpen: false });
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const dark = document.documentElement.classList.contains('dark');
    setThemeLabel(dark ? 'Light Mode' : 'Dark Mode');
  }, []);

  const toggleTheme = () => {
    const root = document.documentElement;
    const dark = root.classList.toggle('dark');
    try { localStorage.setItem('theme', dark ? 'dark' : 'light'); } catch {}
    setThemeLabel(dark ? 'Light Mode' : 'Dark Mode');
  };

  const toggleMenu = () => dispatch({ type: 'SET_MENU_OPEN', menuOpen: !initialState.menuOpen });

  return (
    <header role="banner" className="nav-2025">
      <div className="nav-inner">
        <div className="nav-title shrink-0">
          <img src={`${process.env.PUBLIC_URL}/favicon.ico`} alt="App logo" className="nav-logo" />
          <NavLink to="/home" className="link" activeClassName="active">Workout</NavLink>
        </div>

        <nav className="hidden md:flex items-center gap-3 overflow-hidden">
          {authUser ? (
            <>
              <NavLink to="/home" className="btn-ghost" activeClassName="active">Home</NavLink>
              <NavLink to="/new-workout" className="btn-ghost" activeClassName="active">New</NavLink>
              <NavLink to="/help" className="btn-ghost" activeClassName="active">Help</NavLink>
               <NavLink to="/sign-out" className="btn-ghost" activeClassName="active">Sign Out</NavLink>
              <button onClick={toggleTheme} className="btn-2025" aria-label={themeLabel}>{themeLabel}</button>
            </>
          ) : (
            <>
              <NavLink to="/sign-in" className="btn-ghost" activeClassName="active">Sign In</NavLink>
              <NavLink to="/sign-up" className="btn-ghost" activeClassName="active">Sign Up</NavLink>
              <button onClick={toggleTheme} className="btn-2025" aria-label={themeLabel}>{themeLabel}</button>
            </>
          )}
        </nav>

        <button onClick={toggleMenu} className="btn-icon ml-auto md:hidden" aria-label="Open menu">
          <span className="sr-only">Open menu</span>
          <i className="fas fa-ellipsis-h" aria-hidden="true" />
        </button>
      </div>

      {/* Render outside the header so fixed positioning is true-viewport */}
      {initialState.menuOpen &&
        createPortal(
          <Menu onClose={toggleMenu} onToggleTheme={toggleTheme} themeLabel={themeLabel} />,
          document.body
        )}
    </header>
  );
};

export default NavBar;
